
import ColorTool from './colors/ColorTool'
import MathTool from './math/MathTool.js'
import TextureTool from './texture/TextureTool.js'

export default class GenArt {
  static _singleton;

  constructor(W = 800, H = 800, options) {
    /* console.log( "\n fxHash features: " );
    //console.log( "----------------------------" );
    for( let p in window.$fxhashFeatures ){
      console.log( "  ", p, ": ", window.$fxhashFeatures[p] );
    }
    console.log( "----------------------------" ); */

    GenArt._singleton = this;
    let defaultOptions = {
      margin: 50, 
      palette: 'vivo', 
      bgColor: 'random', 
      bgAlpha: 90
    };
    options = Object.assign({}, defaultOptions, options );
    this.W = W;
    this.H = H;
    this.cX = W * 0.5;
    this.cY = H * 0.5;

    this.colorMode = 'hsb';
    window.p5App.colorMode( window.p5App.HSB, 359, 100, 100, 100);

    this.lastTick = new Date().getTime();

    
    this.margin = options.margin;  
    this.currentPaletteName = options.palette;
    this.currentPalette = ColorTool.palettes[options.palette];
    this.renderMode = options.renderMode;

    if( options.bgColor == 'random' )
      this.setRandomBackgroundColor(options.bgAlpha);
    else
      this.setBackgroundColor( options.bgColor, options.bgAlpha );
    
    /* console.log( "GenArt object created: ");
    console.log( "- palette: ", options.palette );
    console.log( "- bg color: ", options.bgColor ); */
    
    window.p5App.noCanvas();   
    //window.p5App.pixelDensity( window.pixelDensity );
    let cc = window.p5App.createCanvas(this.W, this.H, this.renderMode /* , window.p5App.WEBGL */);   
    //window.p5App.pixelDensity( window.pixelDensity );
    this.build();

    
    //frameRate(300);
  }

  static getUrlParam( name ){
    let url = new URL(window.location.href);
    return url.searchParams.get(name);
  }

  

  onFinished(){
    let autoRefresh = GenArt.getUrlParam( 'autorefresh' );
    console.log( 'onFinished: ', autoRefresh );
    if( autoRefresh ){
      autoRefresh = parseInt( autoRefresh );
      setTimeout( function(){
        console.log( 'onFinished timeout' );
        window.location.reload();
      }, autoRefresh*1000 );
    }
  }

  log(msg, color="#000000", bgColor="#ffffff"){
    console.log( "%c"+msg, "color: "+color+"; background-color: "+bgColor+";" );
  }
  
  setBackgroundColor(color, alpha=100) {
    this.bgColor = window.p5App.color( color );
  }
  
  setRandomBackgroundColor(alpha=100) {
    this.bgColor = this.clrRandom(alpha);
  }

  printCurrentPalette(){
    ColorTool.printPalette(this.currentPaletteName);
  }

  setup() {
  }

  build() {
    //console.log("genart::build");
    this.reset();
  }

  reset(applyNoise) {
    //console.log("genart::reset");
    window.p5App.clear();
    if( applyNoise )
      TextureTool.createNoise(this.W, this.H);
    let clr = this.bgColor;
    window.p5App.background(clr);
    window.p5App.noStroke();
    window.p5App.noFill();
    //blendMode(LIGHTEST);
  }


  tick(msg) {
    let now = new Date().getTime();
    let d = now - this.lastTick;
    console.log("Ellapsed for '", msg, "': ", d);
    this.lastTick = now;
    return d;
  }


  setPalette(name) {
    let result = ColorTool.palettes[name];
    if (result)
      this.currentPalette = result;
    else
      console.error(`Palette "${name}" does not exist :(`);
  }

  setColorMode(mode) {
    this.colorMode = mode;
  }

  clr(index, alpha = 100) {
    return window.p5App.color(...this.currentPalette[index][this.colorMode], alpha);
  }

  colors(alpha = 100) {
    let results = [];
    for (let i = 0; i < this.currentPalette.length; i++) {
      let color = this.currentPalette[i][this.colorMode];
      color = window.p5App.color(color, alpha);
      results.push(color);      
    }
    return results;
  }

  clrRandom(alpha = 100) {
    let index = MathTool.randInt(this.currentPalette.length - 1)
    return this.clr(index, alpha);
  }

  triggerImageGeneratedEvent(scaleFactor=1){
    console.log( 'triggerImageGeneratedEvent. scaleFactor: ', scaleFactor );
    let imageData = scaleFactor < 1 ? 
        this.downScaleCanvas( window.p5App.canvas, scaleFactor ) :
        window.p5App.canvas;
    window.parent.postMessage(
      { 
        type: "imageGenerated", 
        fileName: window.fxhash, 
        imageData: imageData.toDataURL("image/png"), 
        metaData: window.$fxhashFeatures, // To-do: this should probably be the fxhashparams object, 
      }, "*");
  }

  downloadAsImage(scale=1){
    let canvas = document.getElementById("defaultCanvas0");
    if( scale != 1 ){
      canvas = this.downScaleCanvas(canvas, scale);
    }
    let image = canvas.toDataURL("image/png", 1.0).replace("image/png", "image/octet-stream");
    var link = document.createElement('a');
    link.download = fxhash+".png";
    link.href = image;
    link.click();
    link.remove();
  }

  downScaleCanvas(cv, scale) {
    if (!(scale < 1) || !(scale > 0)) throw ('scale must be a positive number <1 ');
    let sqScale = scale * scale; // square scale = area of source pixel within target
    let sw = cv.width; // source image width
    let sh = cv.height; // source image height
    let tw = Math.floor(sw * scale); // target image width
    let th = Math.floor(sh * scale); // target image height
    let sx = 0, sy = 0, sIndex = 0; // source x,y, index within source array
    let tx = 0, ty = 0, yIndex = 0, tIndex = 0; // target x,y, x,y index within target array
    let tX = 0, tY = 0; // rounded tx, ty
    let w = 0, nw = 0, wx = 0, nwx = 0, wy = 0, nwy = 0; // weight / next weight x / y
    // weight is weight of current source point within target.
    // next weight is weight of current source point within next target's point.
    let crossX = false; // does scaled px cross its current px right border ?
    let crossY = false; // does scaled px cross its current px bottom border ?
    let sBuffer = cv.getContext('2d').
    getImageData(0, 0, sw, sh).data; // source buffer 8 bit rgba
    let tBuffer = new Float32Array(3 * tw * th); // target buffer Float32 rgb
    let sR = 0, sG = 0,  sB = 0; // source's current point r,g,b
    /* untested !
    let sA = 0;  //source alpha  */    

    for (sy = 0; sy < sh; sy++) {
        ty = sy * scale; // y src position within target
        tY = 0 | ty;     // rounded : target pixel's y
        yIndex = 3 * tY * tw;  // line index within target array
        crossY = (tY != (0 | ty + scale)); 
        if (crossY) { // if pixel is crossing botton target pixel
            wy = (tY + 1 - ty); // weight of point within target pixel
            nwy = (ty + scale - tY - 1); // ... within y+1 target pixel
        }
        for (sx = 0; sx < sw; sx++, sIndex += 4) {
            tx = sx * scale; // x src position within target
            tX = 0 |  tx;    // rounded : target pixel's x
            tIndex = yIndex + tX * 3; // target pixel index within target array
            crossX = (tX != (0 | tx + scale));
            if (crossX) { // if pixel is crossing target pixel's right
                wx = (tX + 1 - tx); // weight of point within target pixel
                nwx = (tx + scale - tX - 1); // ... within x+1 target pixel
            }
            sR = sBuffer[sIndex    ];   // retrieving r,g,b for curr src px.
            sG = sBuffer[sIndex + 1];
            sB = sBuffer[sIndex + 2];

            /* !! untested : handling alpha !!
            sA = sBuffer[sIndex + 3];
            if (!sA) continue;
            if (sA != 0xFF) {
                sR = (sR * sA) >> 8;  // or use /256 instead ??
                sG = (sG * sA) >> 8;
                sB = (sB * sA) >> 8;
            }
            */
            if (!crossX && !crossY) { // pixel does not cross
                // just add components weighted by squared scale.
                tBuffer[tIndex    ] += sR * sqScale;
                tBuffer[tIndex + 1] += sG * sqScale;
                tBuffer[tIndex + 2] += sB * sqScale;
            } else if (crossX && !crossY) { // cross on X only
                w = wx * scale;
                // add weighted component for current px
                tBuffer[tIndex    ] += sR * w;
                tBuffer[tIndex + 1] += sG * w;
                tBuffer[tIndex + 2] += sB * w;
                // add weighted component for next (tX+1) px                
                nw = nwx * scale
                tBuffer[tIndex + 3] += sR * nw;
                tBuffer[tIndex + 4] += sG * nw;
                tBuffer[tIndex + 5] += sB * nw;
            } else if (crossY && !crossX) { // cross on Y only
                w = wy * scale;
                // add weighted component for current px
                tBuffer[tIndex    ] += sR * w;
                tBuffer[tIndex + 1] += sG * w;
                tBuffer[tIndex + 2] += sB * w;
                // add weighted component for next (tY+1) px                
                nw = nwy * scale
                tBuffer[tIndex + 3 * tw    ] += sR * nw;
                tBuffer[tIndex + 3 * tw + 1] += sG * nw;
                tBuffer[tIndex + 3 * tw + 2] += sB * nw;
            } else { // crosses both x and y : four target points involved
                // add weighted component for current px
                w = wx * wy;
                tBuffer[tIndex    ] += sR * w;
                tBuffer[tIndex + 1] += sG * w;
                tBuffer[tIndex + 2] += sB * w;
                // for tX + 1; tY px
                nw = nwx * wy;
                tBuffer[tIndex + 3] += sR * nw;
                tBuffer[tIndex + 4] += sG * nw;
                tBuffer[tIndex + 5] += sB * nw;
                // for tX ; tY + 1 px
                nw = wx * nwy;
                tBuffer[tIndex + 3 * tw    ] += sR * nw;
                tBuffer[tIndex + 3 * tw + 1] += sG * nw;
                tBuffer[tIndex + 3 * tw + 2] += sB * nw;
                // for tX + 1 ; tY +1 px
                nw = nwx * nwy;
                tBuffer[tIndex + 3 * tw + 3] += sR * nw;
                tBuffer[tIndex + 3 * tw + 4] += sG * nw;
                tBuffer[tIndex + 3 * tw + 5] += sB * nw;
            }
        } // end for sx 
    } // end for sy

    // create result canvas
    let resCV = document.createElement('canvas');
    resCV.width = tw;
    resCV.height = th;
    let resCtx = resCV.getContext('2d');
    let imgRes = resCtx.getImageData(0, 0, tw, th);
    let tByteBuffer = imgRes.data;
    // convert float32 array into a UInt8Clamped Array
    let pxIndex = 0; //  
    for (sIndex = 0, tIndex = 0; pxIndex < tw * th; sIndex += 3, tIndex += 4, pxIndex++) {
        tByteBuffer[tIndex] = Math.ceil(tBuffer[sIndex]);
        tByteBuffer[tIndex + 1] = Math.ceil(tBuffer[sIndex + 1]);
        tByteBuffer[tIndex + 2] = Math.ceil(tBuffer[sIndex + 2]);
        tByteBuffer[tIndex + 3] = 255;
    }
    // writing result to canvas.
    resCtx.putImageData(imgRes, 0, 0);
    return resCV;
  }
}